import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle.js";
import { type_constant } from "../utils/asyncStatus.js";

export const getAllVariants = createAsyncThunk(
  type_constant.GET_ALL_VARIANTS,
  async () => {
    try {
      const response = await apiHandle.get(`get-variants`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
export const getAllTypes = createAsyncThunk(
  type_constant.GET_ALL_TYPES,
  async () => {
    try {
      const response = await apiHandle.get(`get-types`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
